import React, { useState, useEffect } from 'react';

import Module from './Module';
import Lesson from './Lesson';
import QuizAssessment from './QuizAssessment';
import CapstoneProject from './CapstoneProject';
import CodingAssessment from './CodingAssessment';
import Assignment from './Assignment';
import AlmaX from './AlmaX';
import CohortHistory from './CohortHistory';
import Certificate from './Certificate';

import { useLocation } from 'react-router-dom';
import Tracks from './Tracks';
import Mentorship from './Mentorship';
import AbcatDetails from './AbcatDetails';

const sideMenu = [
  'AB-CAT Details',
  'Module',
  'Lesson',
  'Quiz Assessment',
  'Capstone Project',
  'Coding Assessment',
  'Assignment',
  'AlmaX Eligibility',
  'Cohort Change History',
  'Certificates',
  'Tracks',
  'Mentorship',
];

function Progress() {
  const location = useLocation();

  const [current, setCurrent] = useState(0);
  const [userParams, setUserParams] = useState(null);

  const getGoalType = (courseType) => {
    if (courseType === 'data-engineering') return 'dataEngineering';
    if (courseType === 'data-science') return 'dataScience';
    if (courseType === 'web3') return 'web3';
    return null;
  };

  useEffect(() => {
    const userParams = location.state.userParams;
    setUserParams(userParams);
  }, []);

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex gap-8 '>
        {/* sidebar */}
        <div className='w-60'>
          <div className=' bg-white rounded-md flex flex-col'>
            {sideMenu.map((items, index) => (
              <div className='flex flex-col gap-4' key={index}>
                <div
                  className={`mt-4 font-bold cursor-pointer border-solid flex items-center gap-12 ${
                    current === index ? 'text-red-700' : 'text-gray-400'
                  }`}
                  onClick={() => {
                    setCurrent(index);
                  }}
                >
                  <div
                    className={`ring-1 h-12 ring-red-700 ${
                      current === index ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                  {items}
                </div>
                <div className='ring-1 ring-black opacity-10 ' />
              </div>
            ))}
          </div>
        </div>
        <div className='flex-1'>
          <div>
            {current === 0 && (
              <AbcatDetails
              courseType={userParams?.courseType}
                studentId={userParams?.userId}
              />
            )}
          </div>
          <div className='w-full'>
            {current === 1 && (
              <Module
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 2 && (
              <Lesson
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 3 && (
              <QuizAssessment
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 4 && (
              <CapstoneProject
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 5 && (
              <CodingAssessment
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>

          <div>
            {current === 6 && (
              <Assignment
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 7 && (
              <AlmaX
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 8 && <CohortHistory userId={userParams?.userId} />}
          </div>
          <div>
            {current === 9 && (
              <Certificate
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 10 && (
              <Tracks
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
          <div>
            {current === 11 && (
              <Mentorship
                goalType={getGoalType(userParams?.courseType)}
                userId={userParams?.userId}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Progress;
